import { CHECKOUT_LANDING_PATH } from '@/modules/checkout/constants';
import { Stdv1Stat } from '@/modules/observability/constants';
import { recordMetric } from '@/modules/observability/metrics';

type CheckoutRedirectFlow = 'magic_link_login' | 'password_login' | 'signup';

function getPlatformTag() {
  const userAgent = window.navigator?.userAgent || '';

  if (/iPhone|iPad/.test(userAgent)) {
    return /CriOS|FxiOS|EdgiOS/.test(userAgent) ? 'ios_other' : 'ios_safari';
  }

  if (userAgent.includes('Android')) {
    return 'android';
  }

  return 'desktop';
}

export function recordCheckoutRedirectMetric({
  intendedRedirect,
  validatedRedirect,
  flow,
}: {
  intendedRedirect: string | null;
  validatedRedirect: string;
  flow: CheckoutRedirectFlow;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!intendedRedirect?.startsWith(CHECKOUT_LANDING_PATH)) {
    return;
  }

  try {
    const redirectTargetsCheckout = new URL(
      validatedRedirect
    ).pathname.startsWith(CHECKOUT_LANDING_PATH);

    void recordMetric({
      type: 'increment',
      stat: redirectTargetsCheckout
        ? Stdv1Stat[
            'magic_link.tracking.redirect.checkout.has_products.success'
          ]
        : Stdv1Stat[
            'magic_link.tracking.redirect.checkout.has_products.failure'
          ],
      tags: [`flow:${flow}`, `platform:${getPlatformTag()}`],
    }).catch(() => undefined);
  } catch {
    // fail silently
  }
}
